import { observer } from 'mobx-react-lite'
import React, { ChangeEvent, useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router'
import { Button, Form, Segment } from 'semantic-ui-react'
import LoadingComponent from '../../../app/layout/LoadingComponents'
import { useStore } from '../../../app/stores/ardstore'
import { v4 as uuid } from 'uuid'
import { Link } from 'react-router-dom'

export default observer(function ArduinoForm () {
  const history = useHistory()
  const { arduinoStore } = useStore()
  const { createArduino, updateArduino, loading, loadArduino, loadingInitial } = arduinoStore
  const { id } = useParams<{id:string}>()
  const [arduino, setArduino] = useState({
    id: '',
    value: 0
  })

  useEffect(() => {
    if (id) { loadArduino(id).then(arduino => setArduino(arduino!)) }
  }, [id, loadArduino])

  function handleSubmit () {
    if (arduino.id.length === 0) {
      const newArduino = {
        ...arduino,
        id: uuid()
      }
      createArduino(newArduino).then(() => history.push(`/arduinos/${newArduino.id}`))
    } else {
      updateArduino(arduino).then(() => history.push(`/arduinos/${arduino.id}`))
    }
  }
  function handleInputChange (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
    const { name, value } = event.target
    setArduino({ ...arduino, [name]: value })
  }

  if (loadingInitial) return <LoadingComponent content='Loading arduino...'/>
  return (
        <Segment clearing>
            <Form onSubmit={handleSubmit} autoComplete='off'>
                <Form.Input placeholder='Value' value={arduino.value} name='value' onChange={handleInputChange}/>
                <Button loading={loading} floated='right' positive type='submit' content='Submit' />
                <Button as={Link} to='/arduinos' floated='right' type='button' content='Cancel' />
            </Form>
        </Segment>
  )
})
